import React from "react";
import { Link } from "react-router-dom";

export function Logo({ size = "md", to = "/", onClick, variant = "plain" }) {
  const heights = { sm: "h-7", md: "h-9", lg: "h-14" };
  const pad = { sm: "px-2 py-1", md: "px-3 py-1.5", lg: "px-5 py-3" };
  const h = heights[size] || heights.md;

  const img = (
    <img
      src="/logo-v3.webp"
      alt="InfluencerCollab.net – Brands Meet Creators"
      width="1556"
      height="318"
      className={`${h} w-auto object-contain`}
      data-testid="brand-logo-img"
    />
  );

  const inner =
    variant === "pill" ? (
      <div className={`inline-flex items-center bg-white rounded-xl ${pad[size] || pad.md} shadow-[0_0_30px_-8px_rgba(255,59,142,0.5)]`} data-testid="brand-logo">
        {img}
      </div>
    ) : (
      <div className="inline-flex items-center" data-testid="brand-logo">{img}</div>
    );

  if (onClick) return <button onClick={onClick} className="focus:outline-none">{inner}</button>;
  if (to === "#") return inner;
  return <Link to={to} className="focus:outline-none">{inner}</Link>;
}
